import { defineMessages } from 'react-intl';

const cableAndFiberMessages = defineMessages({
    cable: {
        id: 'cable-short',
        defaultMessage: 'C',
    },
    fiber: {
        id: 'fiber-short',
        defaultMessage: 'F',
    },
    cableLong: {
        id: 'cable-long',
        defaultMessage: 'Cable',
    },
    cablePlural: {
        id: 'cable-plural',
        defaultMessage: 'Cables',
    },
    patchCableLong: {
        id: 'patch-cable-long',
        defaultMessage: 'Patch Cable',
    },
    fiberLong: {
        id: 'fiber-long',
        defaultMessage: 'Fiber',
    },
    cableLength: {
        id: 'cable-length-meters',
        defaultMessage: '{length} m.',
    },
    disconnectedFiber: {
        id: 'single-fiber-disconnected',
        defaultMessage: 'Disconnected',
    },
    cablePath: {
        id: 'cable-path',
        defaultMessage: 'Cable path',
    },
});

export default cableAndFiberMessages;
